import { initGraphQLTada } from 'gql.tada';
import type { introspection } from '../../graphql-env';

export const graphql = initGraphQLTada<{
  disableMasking: true;
  introspection: introspection;
  scalars: {
    StatePageSlug: string;
    SuburbPageSlug: string;
    StreetPageSlug: string;
    PagePathname: string;
    Uri: string;
    PropertyPageURL: string;
  };
}>();
